module.exports = __webpack_public_path__ + "static/media/lm1.806dcef3.png";